/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ca-central-1",
    "aws_cognito_identity_pool_id": "ca-central-1:c63a301d-a7dc-415c-ae8e-95f8613710b7",
    "aws_cognito_region": "ca-central-1",
    "aws_user_pools_id": "ca-central-1_J9ZfgmCVn",
    "aws_user_pools_web_client_id": "6i5qj03kq7lnne308g08hmkove",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "matrixspec-prod",
    "aws_user_files_s3_bucket_region": "ca-central-1"
};


export default awsmobile;
